import { POPUP_TEAM_BASE, SERVICE_SEGMENT, isMobileTeamViewport, resolveTeamChatAppUrl } from "./teamNavigation";
import { appNavigate } from "./appNavigateBridge";
import { openWindowWithTabAuth } from "./tabAuthStorage";

/**
 * Abre o módulo Equipe em janela popup (/popup-equipe ou /popup-equipe/:id),
 * com lista de canais/conversas e thread lado a lado no desktop.
 * No mobile, navega para /equipe (ou atendimento) dentro do app principal.
 *
 * @param {string|number|null|undefined} spaceId - ID do space de equipe (chat interno).
 * @param {{ section?: "atendimento" | "service" }} [options]
 */
export function openTeamPopupWindow(spaceId, { section } = {}) {
  if (isMobileTeamViewport()) {
    appNavigate(resolveTeamChatAppUrl(spaceId, { section }));
    return null;
  }

  const sid = spaceId != null ? String(spaceId).trim() : "";
  const useService = section === "atendimento" || section === "service";
  let url;

  if (useService) {
    const base = `${POPUP_TEAM_BASE}${SERVICE_SEGMENT}`.replace(/\/+$/, "");
    url = sid ? `${base}/${encodeURIComponent(sid)}` : base;
  } else {
    url = sid ? `${POPUP_TEAM_BASE}/${encodeURIComponent(sid)}` : POPUP_TEAM_BASE;
  }

  const width = window.screen.availWidth || window.screen.width;
  const height = window.screen.availHeight || window.screen.height;

  return openWindowWithTabAuth(
    url,
    "TeamPopup",
    `width=${width},height=${height},top=0,left=0,scrollbars=no,toolbar=no,location=no,status=no,menubar=no`
  );
}
